import { useUserQuery } from "../common/lib/fetch";
import { useUser } from "../userAccess/useUser";

export interface AvailableBay {
  id: string;
  name: string;
  isCompatible: boolean;
  isTemporarilyDisabled: boolean;
}

export const useGetAvailableBaysForStagedOrder = (stagedOrderId: string) => {
  const user = useUser();

  return useUserQuery<AvailableBay[]>({
    path: `/api/sites/${user.selectedSite?.id}/stagedOrders/${stagedOrderId}/availableBays`,
  });
}
